// Reports API — per-client progress report + trainer business report.
import { http } from "./http";
import type { BusinessReport, ClientReport } from "./types";

export const reportsApi = {
  client: (clientId: number, period = "all", signal?: AbortSignal) =>
    http.get<ClientReport>(
      `/reports/clients/${clientId}`,
      { period },
      signal,
    ),
  business: (period = "all", signal?: AbortSignal) =>
    http.get<BusinessReport>("/reports/business", { period }, signal),
};
